import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { Auth0Provider } from '@auth0/auth0-react';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <Auth0Provider
      domain={process.env.REACT_APP_AUTH0_DOMAIN}
      clientId={process.env.REACT_APP_AUTH0_CLIENT_ID}
      authorizationParams={{
        redirect_uri: window.location.origin + '/callback',
        audience: process.env.REACT_APP_AUTH0_AUDIENCE,
        // D-230 (a): the King's console token also carries the knowledge scopes, so the King can drive the
        // verdict loop from the console — read pending deductions (knowledge:read) and confirm/endorse them
        // (knowledge:curate). The gateway enforces the token's actual scope claim (no King bypass), so the
        // grant must be requested here. Only the King can complete login (the post-login Action denies any
        // user with no kingdom role), so these scopes reach no one else. This also unlocks the Phase-2
        // knowledge views (note.search, graph.export, …) for the King's own console.
        scope: 'openid profile email admin:platform read:infrastructure knowledge:read knowledge:curate'
      }}
      cacheLocation="memory"
      useRefreshTokens={true}
    >
      <App />
    </Auth0Provider>
  </React.StrictMode>
);
